import RedactionItemContainer from './RedactionItemContainer';

export default RedactionItemContainer;